import { render, staticRenderFns } from "./NewEventLocationPage.vue?vue&type=template&id=3dec1fc0&"
import script from "./NewEventLocationPage.vue?vue&type=script&lang=js&"
export * from "./NewEventLocationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports